import React, { useState, useEffect } from "react";

import { useAuth0 } from '@auth0/auth0-react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Form from 'react-bootstrap/Form';
import { useNavigate } from "react-router-dom";
import '../styles/main.css'
import { GetConnectionStatus } from "../utils/GetConnectionStatus";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Image from 'react-bootstrap/Image';
import questionMark from '../images/question_mark.png';
import Table from 'react-bootstrap/Table';
import { getUserPermissions, isAuthorized } from "../utils/Permissions";
import { apiRequest } from "../utils/apiClient";
import { Badge } from "react-bootstrap";


export const TradovateCreds = () => {
    const navigate = useNavigate();
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const userId = user.sub.split('|')[1];

    const [state, setState] = useState({
        accountName: '',
        tradovateUsername: "",
        tradovatePassword: "",
        tradovateAppId: "tradovate_trader(web)",
        tradovateKey: "",
        tradovateDeviceID: "",
        tradovateCHL: "",
        isConnected: false,
        tradovateAccountType: 'demo',
        buid: '',
        autoConnect: false,
        accountStatus: [],
    });

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    };

    const handleCheckboxChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.checked
        });
    };

    //Get necessary data on screen load
    useEffect(() => {
        const getConnectionStatus = async () => {
            let connectionList = [];
            const token = await getAccessTokenSilently();
            await getUserPermissions(token, userId);
            const connectionsResp = await GetConnectionStatus(token, userId);
            const connections = connectionsResp.data;
            if (connections === 'Network Error') {
                setState(previousInputs => ({ ...previousInputs, isConnected: true, isActiveConnection: false }));
            } else {
                for (const userId in connections) {
                    connectionList.push({
                        name: connections[userId].name,
                        isConnected: connections[userId].isConnected,
                        isActiveConnection: connections[userId].isActiveConnection,
                        id: userId,
                    });
                }
                setState(previousInputs => ({ ...previousInputs, accountStatus: connectionList }));
            }
        };
        getConnectionStatus();
        return () => { };
    }, []);

    const ConnectToTradovate = async (e) => {
        e.preventDefault();
        const token = await getAccessTokenSilently();
        const splitDate = new Date().toString().split(' ');
        const timezoneOffset = Number(splitDate[5].substring(3, 6));
        const body = {
            username: state.tradovateUsername,
            password: state.tradovatePassword,
            appId: state.tradovateAppId,
            key: state.tradovateKey,
            deviceID: state.tradovateDeviceID,
            chl: state.tradovateCHL,
            tradovateAccountType: state.tradovateAccountType,
            autoConnect: state.autoConnect,
            timezoneOffset: timezoneOffset,
            accountName: state.accountName,
        };
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        };
        const params = {
            uid: userId
        };
        try {
            const resp = await apiRequest('post', '/algo/demo/data/start', '/api/v2/data/start', {
                headers, params, body,
            });

            state.isConnected = true;
            state.buid = resp.data.buid;
            navigate(`/trade/${resp.data.buid}`);
        } catch (error) {
            console.log(error.message);
            alert("Error Connecting. Try Again");
            return error.message;
        }
    };

    const FormComplete = () => {
        if (
            state.tradovateUsername &&
            state.tradovatePassword &&
            state.tradovateKey &&
            state.tradovateDeviceID &&
            state.tradovateCHL &&
            state.tradovateAccountType &&
            state.accountName
        ) {
            if (state.accountStatus && state.accountStatus.length > 0) {
                for (const account of state.accountStatus) {
                    if (account.name === state.accountName) {
                        return false;
                    }
                }
            }
            return true;
        } else {
            return false;
        }
    }

    const Disconnect = async (name, buid) => {
        const token = await getAccessTokenSilently();
        const headers = {
            'Authorization': `Bearer ${token}`,
        };
        const params = {
            uid: userId,
            buid: buid
        };
        try {
            await apiRequest('get', '/algo/demo/data/stop', '/api/v2/data/stop', {
                headers, params,
            });

            setState(previousInputs => ({ ...previousInputs, isConnected: false }));
            //Find the item in the array to remove
            let accounts = [];
            for (let i = 0; i < state.accountStatus.length; i++) {
                if (state.accountStatus[i].name !== name) {
                    accounts.push(state.accountStatus[i]);
                }
            }
            setState(previousInputs => ({ ...previousInputs, accountStatus: accounts }));
            alert(`You Have Removed Connection: ${name}`);
        } catch (error) {
            console.log(error.message);
            alert("Error Removing Connection. Try Again");
            return error.message;
        }
    };

    const InfoHover = (label, message) => {
        return (
            <span>
                {label} &nbsp;
                <OverlayTrigger
                    key={label}
                    placement="right"
                    overlay={
                        <Tooltip id={label}>
                            {message}
                        </Tooltip>
                    }
                >
                    <Image className="hover-question" src={questionMark} roundedCircle></Image>
                </OverlayTrigger>
            </span>
        )
    }

    const AccountStatuses = () => {
        if (state.accountStatus && state.accountStatus.length > 0) {
            const table = state.accountStatus.map((connection) =>
                <tr key={connection.name}>
                    <td>{connection.name}</td>
                    {/* <td>
                    {connection.isActiveConnection &&
                        <Badge className="mb-3" bg="success">
                            Connected
                        </Badge>
                    }
                    {!connection.isActiveConnection &&
                        <Badge className="mb-3" bg="secondary">
                            Disconnected
                        </Badge>
                    }
                    </td> */}
                    <td>
                        <ButtonGroup size="sm">
                            <Button
                                size="sm"
                                variant="primary"
                                onClick={() => navigate(`/trade/${connection.id}`)}>
                                Trade Settings
                            </Button>
                            <Button
                                size="sm"
                                variant="danger"
                                onClick={() => Disconnect(connection.name, connection.id)}>
                                Delete
                            </Button>
                        </ButtonGroup>
                    </td>
                </tr>
            )
            return (
                <Container key="accountStatusTable">
                    <Row>
                        <Col></Col>
                        <Col xs={10} className="bg-light mt-3 ml-3 mb-4 mr-3 pt-3 pb-3 justify-content-left">
                            <h3 className="border-bottom mb-2 pb-2">
                                Connections
                            </h3>
                            <Row>
                                <Col xs={8}>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                {/* <th>Status</th> */}
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {table}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Col>
                        <Col></Col>
                    </Row>
                </Container>
            )
        }
    }

    return (
        <div>
            {
                isAuthorized('connectionScreen') && (
                    <div>
                        <AccountStatuses />
                        <Container>
                            <Row>
                                <Col></Col>
                                <Col xs={10} className="bg-light mt-3 ml-3 mb-4 mr-3 pt-3 pb-3 justify-content-left">
                                    <h3 className="border-bottom mb-2 pb-2">
                                        Create a Connection To Tradovate
                                    </h3>
                                    <Form className="main-form mb-4 pb-4 pt-4 bg-light">
                                        <Form.Group className="mb-3" controlId="account-name">
                                            <Form.Label><h5>Account Nickname</h5></Form.Label>
                                            <Form.Control
                                                value={state.accountName}
                                                onChange={handleChange}
                                                type="text"
                                                placeholder="Account Nickname"
                                                name="accountName"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="tradovate-username">
                                            <Form.Label><h5>Username</h5></Form.Label>
                                            <Form.Control
                                                value={state.tradovateUsername}
                                                onChange={handleChange}
                                                type="text"
                                                placeholder="Tradovate Username"
                                                name="tradovateUsername"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="tradovate-password">
                                            <Form.Label><h5>Password</h5></Form.Label>
                                            <Form.Control
                                                value={state.tradovatePassword}
                                                onChange={handleChange}
                                                type="password"
                                                placeholder="Tradovate Password"
                                                name="tradovatePassword"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="tradovate-key">
                                            <Form.Label><h5>API Key</h5></Form.Label>
                                            <Form.Control
                                                value={state.tradovateKey}
                                                onChange={handleChange}
                                                type="text"
                                                placeholder="Tradovate API Key"
                                                name="tradovateKey"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="tradovate-device-id">
                                            <Form.Label><h5>Device ID</h5></Form.Label>
                                            <Form.Control
                                                value={state.tradovateDeviceID}
                                                onChange={handleChange}
                                                type="text"
                                                placeholder="Tradovate Device ID"
                                                name="tradovateDeviceID"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="tradovate-chl">
                                            <Form.Label><h5>CHL</h5></Form.Label>
                                            <Form.Control
                                                value={state.tradovateCHL}
                                                onChange={handleChange}
                                                type="text"
                                                placeholder="Tradovate CHL"
                                                name="tradovateCHL"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="tradovate-app-id">
                                            <Form.Label><h5>App ID</h5></Form.Label>
                                            <Form.Control
                                                value={state.tradovateAppId}
                                                onChange={handleChange}
                                                type="text"
                                                placeholder="Tradovate App Id"
                                                name="tradovateAppId"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label><h5>Account Type</h5></Form.Label>
                                            <Form.Check
                                                type="radio"
                                                label="Demo Account / Third Party Funded"
                                                key="thirdPartyFundedAccount"
                                                name="tradovateAccountType"
                                                id="thirdPartyFundedAccount"
                                                checked={state.tradovateAccountType === 'demo'}
                                                onChange={handleChange}
                                                value="demo"
                                            />
                                            {
                                                isAuthorized('tradeLiveAccount') && (
                                                    <Form.Check
                                                        type="radio"
                                                        label="Live Account"
                                                        key="personallyFundedAccount"
                                                        name="tradovateAccountType"
                                                        id="personallyFundedAccount"
                                                        checked={state.tradovateAccountType === 'live'}
                                                        onChange={handleChange}
                                                        value="live"
                                                    />
                                                )
                                            }
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="autoConnect">
                                            <Form.Label><h5>Connect Automatically</h5></Form.Label>
                                            <Form.Check
                                                type="switch"
                                                label={InfoHover('Connect Automatically', 'When toggled on, ALM Trading will automatically connect for you starting the next trading day.')}
                                                key="autoConnect"
                                                name="autoConnect"
                                                checked={state.autoConnect}
                                                onChange={handleCheckboxChange}
                                                value={state.autoConnect}
                                            />
                                        </Form.Group>
                                        <div className="d-flex justify-content-center">
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                onClick={async (e) => await ConnectToTradovate(e)}
                                                disabled={!FormComplete()}>
                                                Connect
                                            </Button>
                                        </div>
                                        <div>
                                            <a
                                                href="/trade"
                                                className="d-flex justify-content-left mt-5">
                                                Continue without connecting
                                            </a>
                                        </div>
                                    </Form>
                                </Col>
                                <Col></Col>
                            </Row>
                        </Container>
                    </div>
                )}
        </div>
    )
}

